export default function currencyByLanguage(i18n) {
  var money = {};

  if (i18n === "en") {
    return (money = { decimal: ".", thousands: ",", precision: 2 });
  } else {
    return (money = { decimal: ",", thousands: ".", precision: 2 });
  }
}
